import { isEqual, omit, pick, pickBy } from 'lodash'
import getOne from './getOne'
import update from './update'

/**
 * A tela Aplicativo edita um registro que no servidor são três rotas: a configuração da
 * rede (`chains-config`), o cadastro da rede (`chains`, só PontuaX) e os textos do app
 * (`app-labels`). Cada campo continua indo para a rota que já o gravava — é ela que
 * confere a permissão.
 *
 * Não é atômico: se a segunda rota falhar, o que foi pela primeira já está gravado.
 */

// O PATCH /chains-config não aceita estes campos; quem grava é o PATCH /chains.
export const APP_CONFIG_CHAIN_FIELDS = [
  'appName', 'appNameInsideApp', 'appNameStore', 'appSlogan', 'appPhone',
  'appColor', 'appHeaderLabelColor', 'appSignUpButtonColor', 'appSignInButtonColor',
  'appLogoWidth', 'appShowWelcomeLabel',
  'appInstagram', 'appTwitter', 'appYoutube', 'appFacebookPageId', 'appFacebook',
  'firebaseProjectId', 'googlePackageName', 'applePackageName', 'appleAppId',
  'appMinBuild', 'appForceUpdate',
  'appOnlyCompletelyFillin', 'useVehicleOdometer',
  'hasValidationTokenByMessage', 'appUseQrCodeForSignup', 'useCode2fa',
]

// Texto nunca preenchido chega como `undefined` no formulário e `null` do servidor.
const filledLabels = (appLabel) => pickBy(omit(appLabel || {}, 'chainId'), value => value != null)

export const appLabelsChanged = (data, previousData) =>
  !isEqual(filledLabels(data?.appLabel), filledLabels(previousData?.appLabel))

export const getAppConfig = async (params) => {
  const [config, labels] = await Promise.all([
    getOne('chains-config', params),
    getOne('app-labels', params),
  ])

  return { data: { ...config.data, appLabel: labels.data?.appLabel || {} } }
}

export const updateAppConfig = async (_resourceName, params) => {
  const { id, data, previousData } = params
  const notConfig = [...APP_CONFIG_CHAIN_FIELDS, 'appLabel']

  // Mesmo envio que a tela de Configurações sempre fez: o `update` compara com o
  // registro anterior e manda só o que mudou (o `firebaseConfig` vai sempre).
  const configResult = await update('chains-config', {
    id,
    data: omit(data, notConfig),
    previousData: omit(previousData, notConfig),
  })
  let record = { ...previousData, ...configResult.data }

  const chainKeys = APP_CONFIG_CHAIN_FIELDS.filter(key => key in data && !isEqual(data[key], previousData?.[key]))
  if (chainKeys.length) {
    const chainResult = await update('chains', { id, data: pick(data, chainKeys), previousData: {} })
    record = { ...record, ...pick(chainResult.data, APP_CONFIG_CHAIN_FIELDS) }
  }

  if (appLabelsChanged(data, previousData)) {
    const labelsResult = await update('app-labels', { id, data: { appLabel: omit(data.appLabel, 'chainId') }, previousData: {} })
    record = { ...record, appLabel: labelsResult.data?.appLabel ?? data.appLabel }
  }

  return { data: record }
}
